import { BasisDetailsInterface } from './basis-details.interface';
import { ForecastTrend } from '@prlw/core/monitor/forecast-trend.entity';
import { Instrument } from '@prlw/core/monitor/instrument.entity';
import { AllInstruments } from '@prlw/core/monitor/all-instruments.entity';
import { ShipmentBasisStations } from '@prlw/core/monitor/shipment-basis-stations.entity';

const FORECAST_DESCRIPTIONS = {
  [ForecastTrend.Up]: 'рост (более 250 \u20BD/т)',
  [ForecastTrend.Down]: 'падение (более -250 \u20BD/т)',
  [ForecastTrend.Lateral]: 'боковой тренд (+/-250 \u20BD/т)',
};

export class BasisDetails implements BasisDetailsInterface {
  public code!: string;
  public shipmentBasisName!: string;
  public briefDescription: string | null = null;
  public manufacturers!: string[];
  public stations!: ShipmentBasisStations[];
  public instrumentCode!: string;
  public instrumentName!: string;
  public forecastTrend!: ForecastTrend | null;
  public forecastDate!: string | null;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static fromInstrument(instrument: Instrument): BasisDetails {
    const details = new BasisDetails();
    details.code = instrument.shipment.code;
    details.briefDescription = instrument.shipment.briefDescription;
    details.shipmentBasisName = instrument.shipment.name;
    details.manufacturers = instrument.shipment.plants.map(
      (plant) => plant.name,
    );
    details.stations = instrument.shipmentBasisStations;
    details.instrumentCode = instrument.instrumentCode;
    details.instrumentName = instrument.instrumentName;
    details.forecastTrend = instrument.forecastTrend;
    details.forecastDate = instrument.forecastDate;
    return details;
  }

  public static fromAllInstruments(instrument: AllInstruments): BasisDetails {
    const details = new BasisDetails();
    details.code = instrument.shipmentBasisData.code;
    details.stations = instrument.shipmentBasisData.stations;
    details.manufacturers = instrument.shipmentBasisData.manufacturers;
    details.shipmentBasisName = instrument.shipmentBasisData.shipmentBasisName;
    details.instrumentCode = '';
    details.instrumentName = '';
    details.forecastTrend = null;
    details.forecastDate = null;
    return details;
  }

  public get forecastDescription(): string {
    return this.forecastTrend ? FORECAST_DESCRIPTIONS[this.forecastTrend] : '';
  }
}
